import getDecorators from 'inversify-inject-decorators';
import { rootContainer } from '../ioc';

import { SavedCreditCardsStore } from './stores/saved-credit-cards.store';
import { PaymentGateway } from 'src/statement/stores/payment-gateway.store';
import { SavedPaymentMethodsStore } from './stores/saved-payment-methods.store';
import { ClientDataStore } from 'src/core/stores/client-data.store';

export const paymentMethodsContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(paymentMethodsContainer);

paymentMethodsContainer.bind(SavedCreditCardsStore).toSelf().inSingletonScope();
paymentMethodsContainer.bind(PaymentGateway).toSelf().inSingletonScope();
paymentMethodsContainer.bind(SavedPaymentMethodsStore).toSelf().inSingletonScope();
paymentMethodsContainer.bind(ClientDataStore).toSelf().inSingletonScope();
